import React from "react";
import { CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY } from "config/PageAnchorConfig/CampaignAnchorConfig";
import { LinkSection } from "components/base/LinkSection";


const LinkedCouponDetailCard = ({
  couponSet,
}) => {

  return (
    <div
      id={CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.linkedCoupon}
      className='create-step-section-item'
    >
      <label className="create-section-title">
        COUPON SET
      </label>

      <label className="create-section-label create-section-label-bottom-space">
        Link to the coupon set
      </label>

      <div>
        <label className="create-section-field-input list-new-line">
          {`[ID: ${couponSet?.pk}] ${couponSet?.name}`}
        </label>
        <LinkSection
          link={`/coupons/${couponSet?.pk}/`}
          linkText="View coupon set"
          disableLink={couponSet?.toDelete}
          disableLinkText="Deleted"
        />
      </div>

      <label className="create-section-label create-section-label-bottom-space">
        Total number of coupon from linked coupon set
      </label>
      <label className="create-section-field-input list-new-line">
        {
          `Acquired/Used/Total Stock: ${couponSet?.totalNumberOfAcquiredCoupons || 0
          }/${couponSet?.totalNumberOfUsedCoupons || 0}/${couponSet?.totalNumberOfGeneratedCoupons || 0
          }`
        }
      </label>
    </div>
  )
}

export default LinkedCouponDetailCard;
